import { render, staticRenderFns } from "./SummaryDataAmount.vue?vue&type=template&id=77e8acf6"
import script from "./SummaryDataAmount.vue?vue&type=script&lang=js"
export * from "./SummaryDataAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports